export const FormCodes = {
	TERMS: 1001,
	HOUSE_SIZE: 1002,
	SETUP_ADDRESS: 1003
};

export const ServerCodes = {

};
